import React from 'react'
import '../styles/map.css'
import MapPage from '../img/ff.jpeg'

const Person = () =>{
  return(
    <section className='map'>
<img alt="map" src={MapPage}/>
    </section>
  )
}
export default Person;
